import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { formatDate } from "../../constants/DateUtil/DateUtil";
import { Button } from "primereact/button";
import { getAllCustomerPackageOffer, getCustomerPackageOffer } from "../../services/CustomerPackageOffer/CustomerPackageOffer";
import { CustomerOrderPackageLog } from "../../services/PackageLog/PackageLog";
import CustomerStorePackageOfferReSubscribeModal from "../CustomerComponent/PackageOffers/CustomerStorePackageOfferReSubscribeModal";
import CustomerStorePackageOfferReSubscribeModalAdmin from "../CustomerComponent/PackageOffers/CustomerStorePackageOfferReSubscribeModalAdmin";
import { getUserData } from "../../utils/localStorage";

export default function CustomerPackagesModal({
  customerPackagesModalVisible,
  setCustomerPackagesModalVisible,
  storeLoadData,
  storeId,
  storeCustomerId,
  brandId,
  brandCarryForwardApplyOn,
}) {

const { storeData, userProfileData, userProfileRole } = getUserData();

  let storeUserId = userProfileData.id;
  const gstValue = storeData.gst;
  const storeGstNumber = storeData.gstNo;
  const storeGstType = storeData.gstType;

  let enabledUPIAccount = storeData.enabledUPIAccount;
  let upiAccountId = storeData.upiAccountId;
  let upiAccountLink = storeData.upiAccountLink;
  let upiAccountName = storeData.upiAccountName;
  let enabledQRDeviceModal = storeData.enabledQRDeviceModal;

  const [customerPackageOfferData, setCustomerPackageOfferData] = useState([]);
  const [customerOrderPackageLogAllData, setCustomerOrderPackageLogAllData] = useState([])
  const [
      customerStorePackageOfferReSubscribeModalVisible,
      setCustomerStorePackageOfferReSubscribeModalVisible,
    ] = useState("");
  
    const [
      customerStorePackageOfferReSubscribeModalData,
      setCustomerStorePackageOfferReSubscribeModalData,
    ] = useState({});

  const fetchCustomerPackageOfferList = (data) => {
    getAllCustomerPackageOffer(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.filter(
            (item) =>
              (item.status === "ACTIVE" || item.status === "RUNNING") &&
              item.leftDiscount > 0
          );
          setCustomerPackageOfferData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchPackageLogAllData = (data) => {
    CustomerOrderPackageLog({
      ...data,
      limit: 100,
      offset: 0,
    })
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data.filter(
            (item) =>
              item.packageDTO.status === true && item.carryForwardCount > 0
          );
          setCustomerOrderPackageLogAllData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const receiveDataFromOfferAddModal = ({ success }) => {
    if (success) {
      const requestData = {
        statusIn:["ACTIVE", "RUNNING"],
        brandId: brandId,
        storeCustomerId: [storeCustomerId],
      };

      fetchCustomerPackageOfferList(requestData);
    }
  };

  useEffect(() => {
    const requestData = {
      statusIn: ["ACTIVE", "RUNNING",],
      brandId: brandId,
      storeCustomerId: [storeCustomerId],
    };

    fetchCustomerPackageOfferList(requestData);

    const packageLogData = {
      storeIds: [storeId],
      brandId: brandId,
      sortOrder: "desc",
      sortBy: "id",
      leftCarryForward: true,
      statusIn:
        brandCarryForwardApplyOn === "running"
          ? [
              "BOOKED",
              "INPROCESS",
              "PROCESSED",
              "IN_WAREHOUSE",
              "OUT_FOR_DELIVERY",
              "DONE",
              "DELIVERED",
            ]
          : ["DONE", "DELIVERED"], // add
      packageIdIn: [],
      storeCustomerId: storeCustomerId,
      valid: true,
    };
    fetchPackageLogAllData(packageLogData);
  }, [customerPackagesModalVisible]);

  const handleModalClose = () => {
    setCustomerPackagesModalVisible(false);
  };

  const totalData = storeLoadData?.loadData?.reduce(
    (acc, item) => acc + item.loadCount,
    0
  );

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={customerPackagesModalVisible}
        style={{ width: "80vw" }}
        onHide={() => {
          if (!customerPackagesModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
              height: "70vh",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <div></div>
              <div className="flex justify-content-center align-items-center gap-2">
                <div className="flex justify-content-center align-items-center">
                  <p className="text-white-alpha-90 text-3xl text-primary-50 font-semibold text-center">
                    Active Packages
                  </p>
                </div>
              </div>

              <Button
                label="x"
                onClick={() => handleModalClose()}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div
              className="h-30rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="flex-1 my-1 mx-2">
                {customerPackageOfferData.length > 0 ? <div>
                  <p className=" text-2xl text-center font-semibold capitalize">
                    Subscription Package
                  </p>
                  <div>
                    {customerPackageOfferData?.map((item) => (
                      <div className="px-2">
                        <div className="grid mt-1">
                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Offer Name :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item.brandPackageOffer.name.replace(/_/g, " ")}
                            </p>
                          </div>

                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Service Value :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item.brandPackageOffer.serviceValue}
                            </p>
                          </div>

                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Package Value :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item.brandPackageOffer.packageValue}
                            </p>
                          </div>
                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Left Service Value :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {/*item.leftDiscount > 0 ? item.leftDiscount : 0*/}
                              {item.leftServiceValue}
                            </p>
                          </div>
                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Valid From :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {formatDate(item.validFrom)}
                            </p>
                          </div>

                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Valid To :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {formatDate(item.validTo)}
                            </p>
                          </div>
                          {userProfileRole === "BY_STORE" && <div className="col">
                            {["RUNNING", "CONSUME"].includes(item.status) && (
                              <div>
                                <p className="text-md font-normal capitalize">
                                  Re-Subscribe :
                                </p>
                                <div
                                  onClick={() => {
                                    setCustomerStorePackageOfferReSubscribeModalVisible(true);
                                    setCustomerStorePackageOfferReSubscribeModalData(item);
                                  }}
                                  style={{ marginRight: 10, marginTop: 5 }}
                                >
                                  <i
                                    className="pi pi-sync"
                                    style={{
                                      fontSize: "27px",
                                      cursor: "pointer",
                                      color: "blue",
                                    }}
                                  ></i>
                                </div>
                              </div>
                            )}
                          </div>}
                        </div>
                      </div>
                    ))}
                  </div>
                </div> : 
                  <p className=" text-xl text-center font-semibold capitalize" style={{color:"red"}}>
                    No Active or Running Subscription Package Found
                  </p>
              }
              </div>
              <div className="flex-1 my-1 mx-4">
                {customerOrderPackageLogAllData.length > 0 ?<div>
                  <p className=" text-2xl text-center font-semibold capitalize">
                    Carry Forward Package
                  </p>
                  <div>
                    {customerOrderPackageLogAllData?.map((item) => (
                      <div className="px-4">
                        <div className="grid mt-1">
                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Package Name :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item?.packageDTO?.name || "N/A"}
                            </p>
                          </div>

                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Quantity :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item?.packageDTO?.serviceUnit === "Qty"
                                ? item.packageDTO.quantity + " Pcs"
                                : item.packageDTO.quantity +
                                  " " +
                                  item.packageDTO?.serviceUnit}
                            </p>
                          </div>

                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Package Amount :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item?.packageDTO?.amount}
                            </p>
                          </div>
                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Quantity Used :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item?.packageDTO?.serviceUnit === "Qty"
                                ? item.itemCount + item.countGram + " Pcs"
                                : item.itemCount +
                                  item.countGram +
                                  " " +
                                  item.packageDTO?.serviceUnit}
                            </p>
                          </div>
                          <div className="col">
                            <p className="text-md font-normal capitalize">
                              Left Quantity :
                            </p>
                            <p className="text-lg font-semibold capitalize">
                              {item?.packageDTO?.serviceUnit === "Qty"
                                ? item.carryForwardCount + " Pcs"
                                : item.carryForwardCount +
                                  " " +
                                  item.packageDTO?.serviceUnit}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                  : <p className=" text-xl text-center font-semibold capitalize" style={{ color: "red" }}>
                    No Carry Forward Package Found
                  </p>
            }
              </div>
            </div>
          </div>
        )}
      ></Dialog>

      {customerStorePackageOfferReSubscribeModalVisible && userProfileRole === "BY_STORE" && (
          <CustomerStorePackageOfferReSubscribeModal
            customerStorePackageOfferReSubscribeModalVisible={
              customerStorePackageOfferReSubscribeModalVisible
            }
            setCustomerStorePackageOfferReSubscribeModalVisible={
              setCustomerStorePackageOfferReSubscribeModalVisible
            }
            sendDataToCustomerPackageOffer={receiveDataFromOfferAddModal}
            ReSubscribeModalData={
              customerStorePackageOfferReSubscribeModalData
            }
            brandId={brandId}
            storeCustomerId={storeCustomerId}
            storeId={storeId}
            storeUserId={storeUserId}
            gstValue={gstValue}
            storeGstNumber={storeGstNumber}
            storeGstType={storeGstType}
            enabledUPIAccount={enabledUPIAccount}
            upiAccountId={upiAccountId}
            upiAccountLink={upiAccountLink}
            upiAccountName={upiAccountName}
            enabledQRDeviceModal={enabledQRDeviceModal}
          />
        )  }
    </div>
  );
}
